module.exports = __webpack_public_path__ + "img/background.84e12b54.jpg";